<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />

        <action-button type="save" @click="save" v-if="$can('enrolment-edit') || $can('companies-access')" />
        <action-button type="delete" @click="del(enrolment.id)" v-if="$can('enrolment-delete') && !modal" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.name"
                  v-model="department.name"
                  :label="$t('enrolments.name')"
                  class="required-field"
                  v-validate="'required'"
                  :error-messages="errors.collect('name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.number"
                  v-model="department.number"
                  :label="$t('enrolments.number')"
                  :error-messages="errors.collect('number')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="participants.employees"
                  v-model="department.participant_id"
                  :items="participants"
                  item-text="full_name"
                  item-value="id"
                  :label="$t('enrolments.dept_chief')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('participants.employees')"
                  clearable
                >
                  <template v-slot:append-outer>
                    <action-button type="new" :icon_only="true" small @click="showForm(null, 'participant')" />
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  dense
                  name="enrolments.comment"
                  v-model="department.comments"
                  :label="$t('addresses.comments')"
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("enrolments.address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.street"
                  v-model="department.street"
                  :label="$t('enrolments.p_address_street')"
                  v-validate="'max:50'"
                  :error-messages="errors.collect('p_address_street')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.zip"
                  v-model="department.zip"
                  :label="$t('enrolments.p_address_zip')"
                  v-validate="'max:6'"
                  :error-messages="errors.collect('p_address_zip')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.city"
                  v-model="department.city"
                  v-validate="'max:50'"
                  :label="$t('enrolments.p_address_city')"
                  :error-messages="errors.collect('p_address_city')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="p_address_country"
                  v-model="department.country"
                  :items="this.$dd_countries()"
                  item-text="text"
                  item-value="key"
                  :label="$t('fe.enrolment.p_address_country')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('p_address_country')"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>

    <v-dialog v-model="showDialogForm" persistent max-width="90%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          :from_id_2="enrolment_organisation_id"
          :from_module_2="currentFromModule"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "FormDepartment",

  props: ["id", "enrolment_organisation_id", "modal"],

  components: {
    "participant-form": () => import("../../participants/components/Form")
  },

  data() {
    return {
      page_title: "",
      predata: {},
      department: {},
      participants: [],

      currentFormId: null,
      currentForm: null,
      currentFromModule: "department",
      showDialogForm: false,

      dictionary: {
        attributes: {
          name: this.$t("fe.enrolment.name"),
          p_address_street: this.$t("fe.enrolment.p_address_street"),
          p_address_city: this.$t("fe.enrolment.p_address_city"),
          p_address_state: this.$t("fe.enrolment.p_address_state"),
          p_address_zip: this.$t("fe.enrolment.p_address_zip"),
          p_address_country: this.$t("fe.enrolment.p_address_country")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.deaprtment, this.predata, this.save, this.isFormValid)
    })
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    }
  },

  methods: {
    init() {
      axios
        .get(this.API_URL + "enrolment/organisation/" + this.enrolment_organisation_id)
        .then((res) => {
          if (this.id) {
            axios
              .get(this.API_URL + "enrolmentorganisationdepartment/" + this.id)
              .then((res) => {
                this.department = res.data.data
                this.page_title = this.$t("enrolments.edit_department")

                // JSON stringify and parse to remove variable reactiveness
                this.predata = JSON.parse(JSON.stringify(this.department))
                this.student_list()
              })
              .catch((err) => console.log(err))
          } else {
            this.page_title = this.$t("enrolments.new_department")
            this.department.enrolment_organisation_id = this.enrolment_organisation_id
            this.predata = JSON.parse(JSON.stringify(this.department))
            this.student_list()
          }
        })
        .catch((err) => console.log(err))
    },
    student_list() {
      if (this.enrolment_organisation_id) {
        axios
          .get(
            this.API_URL +
              "participants" +
              "?resourcetype=user-ddlist&show_all=true&returntype=kompetanse&query_company_id=" +
              this.enrolment_organisation_id +
              "&query_tenant_user_status=1"
          )
          .then((res) => {
            this.participants = res.data
          })
          .catch((err) => console.log(err))
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.department.id) {
              axios
                .post(this.API_URL + "enrolmentorganisationdepartment", this.department)
                .then((res) => {
                  vm.department = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.department))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "department",
                      mode: "create",
                      data: res.data.data
                    })
                  } else {
                    vm.$awn.success(vm.$t("global.create_success"))
                  }
                })
                .catch((err) => console.log(err))
            } else {
              axios
                .put(this.API_URL + "enrolmentorganisationdepartment", this.department)
                .then((res) => {
                  vm.department = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.department))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "department",
                      mode: "update",
                      data: res.data.data
                    })
                  } else {
                    vm.$awn.success(vm.$t("global.update_success"))
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.department.participant_id = data.data.id || null
      this.student_list()
      this.return_modal_cancel_form()
    },
    return_modal_cancel_form() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
    }
  }
}
</script>

<style>
p.price,
.price span {
  font-size: 14px !important;
}
</style>
